let audioContext = null;
let audioUnlocked = false;

/* ============================================================
   AUDIO
   ============================================================ */

function getAudioContext() {
  if (!audioContext) {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;

    if (!AudioCtx) {
      console.warn("Calendario VH: AudioContext no disponible");
      return null;
    }

    audioContext = new AudioCtx();
  }

  return audioContext;
}


/*
 * Desbloquea el audio después de una interacción real
 * del usuario.
 */
export async function unlockNotificationAudio() {
  try {
    const ctx = getAudioContext();

    if (!ctx) {
      return false;
    }

    if (ctx.state === "suspended") {
      await ctx.resume();
    }

    audioUnlocked = ctx.state === "running";

    console.log(
      "Calendario VH: audio",
      audioUnlocked ? "DESBLOQUEADO" : "BLOQUEADO"
    );

    return audioUnlocked;

  } catch (error) {
    console.warn(
      "Calendario VH: no se pudo desbloquear el audio",
      error
    );

    return false;
  }
}


/*
 * Escuchamos varias formas de interacción.
 *
 * Esto es deliberado:
 * Brave/Chrome pueden comportarse distinto dependiendo
 * de cómo se produjo la interacción.
 */
export function setupNotificationAudioUnlock() {

  const unlock = () => {
    void unlockNotificationAudio();
  };

  window.addEventListener("pointerdown", unlock, {
    passive: true,
    capture: true,
  });

  window.addEventListener("touchstart", unlock, {
    passive: true,
    capture: true,
  });

  window.addEventListener("click", unlock, {
    passive: true,
    capture: true,
  });

  window.addEventListener("keydown", unlock, {
    passive: true,
    capture: true,
  });

  return () => {
    window.removeEventListener("pointerdown", unlock, true);
    window.removeEventListener("touchstart", unlock, true);
    window.removeEventListener("click", unlock, true);
    window.removeEventListener("keydown", unlock, true);
  };
}


/*
 * Reproduce el sonido de notificación.
 */
export async function playNotificationSound() {
  try {

    const ctx = getAudioContext();

    if (!ctx) {
      return false;
    }

    /*
     * Si el navegador suspendió el contexto,
     * intentamos reactivarlo.
     */
    if (ctx.state === "suspended") {
      await ctx.resume();
    }

    if (ctx.state !== "running") {
      console.warn(
        "Calendario VH: AudioContext no está running:",
        ctx.state
      );

      return false;
    }

    audioUnlocked = true;

    const now = ctx.currentTime;

    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();

    oscillator.type = "sine";

    /*
     * Primer tono.
     */
    oscillator.frequency.setValueAtTime(
      880,
      now
    );

    /*
     * Segundo tono.
     */
    oscillator.frequency.setValueAtTime(
      1174.66,
      now + 0.10
    );

    /*
     * Volumen.
     */
    gain.gain.setValueAtTime(
      0.0001,
      now
    );

    gain.gain.exponentialRampToValueAtTime(
      0.18,
      now + 0.015
    );

    gain.gain.exponentialRampToValueAtTime(
      0.0001,
      now + 0.45
    );

    oscillator.connect(gain);
    gain.connect(ctx.destination);

    oscillator.start(now);
    oscillator.stop(now + 0.45);

    console.log(
      "🔊 Calendario VH: sonido reproducido"
    );

    return true;

  } catch (error) {

    console.warn(
      "Calendario VH: error reproduciendo sonido",
      error
    );

    return false;
  }
}


/* ============================================================
   FAVICON
   ============================================================ */

export function setFaviconBadge(count) {

  const existing = document.querySelector(
    'link[data-dynamic-favicon="true"]'
  );

  if (count <= 0) {

    if (existing) {
      existing.remove();
    }

    return;
  }

  const baseIcon = new Image();

  baseIcon.onload = () => {

    const canvas = document.createElement("canvas");

    canvas.width = 64;
    canvas.height = 64;

    const ctx = canvas.getContext("2d");

    if (!ctx) {
      return;
    }

    ctx.clearRect(0, 0, 64, 64);

    ctx.drawImage(
      baseIcon,
      0,
      0,
      64,
      64
    );

    const badgeRadius =
      count > 9 ? 22 : 19;

    ctx.beginPath();

    ctx.arc(
      47,
      17,
      badgeRadius,
      0,
      Math.PI * 2
    );

    ctx.fillStyle = "#ef4444";
    ctx.fill();

    ctx.lineWidth = 3;
    ctx.strokeStyle = "#ffffff";
    ctx.stroke();

    ctx.fillStyle = "#ffffff";

    ctx.font = "bold 22px Arial";

    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    const text =
      count > 99
        ? "99+"
        : String(count);

    ctx.fillText(
      text,
      47,
      17
    );

    let link = document.querySelector(
      'link[data-dynamic-favicon="true"]'
    );

    if (!link) {

      link = document.createElement("link");

      link.rel = "icon";
      link.type = "image/png";

      link.dataset.dynamicFavicon = "true";

      document.head.appendChild(link);
    }

    link.href =
      canvas.toDataURL("image/png");
  };

  baseIcon.src = "/icon-192.png";
}


/* ============================================================
   TITULO
   ============================================================ */

export function updateDocumentTitle(unread) {

  document.title =
    unread > 0
      ? `🔔 (${unread}) Calendario VH`
      : "Calendario VH";
}


/* ============================================================
   NOTIFICACIÓN
   ============================================================ */

export async function notifyNewNotification(notification) {

  const title =
    notification?.title ||
    "Nueva notificación";

  const message =
    notification?.message ||
    "";

  console.log(
    "🔔 Calendario VH: NUEVA NOTIFICACIÓN",
    {
      title,
      message,
      id: notification?.id,
    }
  );


  /* ------------------------------------------------------------
     1. SONIDO
     ------------------------------------------------------------ */

  await playNotificationSound();


  /* ------------------------------------------------------------
     2. NOTIFICACIÓN DEL SISTEMA
     ------------------------------------------------------------ */

  try {

    if (
      "Notification" in window &&
      Notification.permission === "granted"
    ) {

      /*
       * Preferimos Service Worker.
       *
       * Ya comprobamos que este mecanismo funciona
       * correctamente en este navegador.
       */

      if ("serviceWorker" in navigator) {

        const registration =
          await navigator.serviceWorker.ready;

        await registration.showNotification(
          title,
          {
            body: message,

            icon: "/icon-192.png",

            badge: "/icon-192.png",

            tag:
              notification?.id ||
              "calendario-vh",

            renotify: true,

            requireInteraction: false,

            data: {
              url: "/notificaciones",
              notificationId:
                notification?.id || null,
            },
          }
        );

        console.log(
          "🔔 Calendario VH: notificación del sistema enviada"
        );

      } else {

        /*
         * Fallback.
         */

        new Notification(
          title,
          {
            body: message,
            icon: "/icon-192.png",
            tag:
              notification?.id ||
              "calendario-vh",
          }
        );

        console.log(
          "🔔 Calendario VH: Notification API utilizada"
        );
      }
    }

  } catch (error) {

    console.warn(
      "Calendario VH: no se pudo mostrar la notificación del sistema",
      error
    );
  }


  /* ------------------------------------------------------------
     3. EVENTO INTERNO DE LA APP
     ------------------------------------------------------------ */

  window.dispatchEvent(
    new CustomEvent(
      "calendario:new-notification",
      {
        detail: notification,
      }
    )
  );
}